import React, { Component } from 'react';

import Accessibility from './widgets/Accessibility';
import Affordability from './widgets/Affordability';
import ListingsForAppfolio from './widgets/listingsForAppfolio';
import Trustpilot from './widgets/Trustpilot';
import TripAdvisior from './widgets/TripAdvisior';
import Yelp from './widgets/Yelp';
import Prorated from './widgets/Prorated';
import MonthlyPayment from './widgets/monthlyPayment';

import Button from '../Button';
import EditorLeftbar from './EditorLeftbar';
import handlePreviewHtml from './WidgetPreviewHandler';
import PurchasePopup from './PurchasePopup';
import InstallPopup from '../InstallPopup';
import ListForRentvine from './widgets/listForRentvine';
import apiInstance from '../apiInstance';
import ResenMailPopup from '../Popups/ResenMailPopup';
import widgetAboutData from './data/about-data';
import InfoPopup from './InfoPopup';
;

class WidgetWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedEditor: 'Builder',
            widget: {
                widgetType: '',
                id: '',
                title: '',
                htmlData: {},
                isPro: false,
            },
            previewHtml: '',
            fieldErrors: '',
            displayName: '',
            email: '',
            emailVerified: '',
            // verifyPassPopup: React.createRef(),
            purchasePopup: React.createRef(),
            installPopup: React.createRef(),
            verifyMailPopup: React.createRef(),
            infoPopup: React.createRef()
        };

    }

    async updateWidgetStatus(id) {
        try {

            const response = await apiInstance.get(`/widget/status/${id}`);
            const { subStatus, expires } = response.data;

            this.setState(
                (prevState) => ({
                    widget: {
                        ...prevState.widget,
                        subStatus: subStatus,
                        expires: expires,
                    },
                })
            );

            return response.data;

        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }

    async getUser() {
        try {
            const response = await apiInstance.get('/user/profile');
            const { displayName, email, emailVerified } = response.data.user;

            await new Promise((resolve) =>
                this.setState({ displayName, email, emailVerified }, resolve)
            );

        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }

    handleLeftBarClick = (editor) => {
        this.setState({
            selectedEditor: editor,
        });
    };

    updateWrapperWidget = async (widgetForWrapper) => {
        this.setState((prevState) => ({
            ...prevState,
            widget: widgetForWrapper,
        }));
    }

    previewWidgetOnClick = async () => {
        const { widget } = this.state;
        this.previewWidget(widget);
    };

    previewWidget = async (widgetForPreview) => {

        this.setState({ previewHtml: '<div>Loading...</div>' });

        // previewWidget is being called from child widgets and now let's set that widget for this wrapper
        this.setState((prevState) => ({
            ...prevState,
            widget: widgetForPreview,
        }));

        if (widgetForPreview.widgetType) {

            const data = await handlePreviewHtml(widgetForPreview);

            if (data.error) {
                const { handleErrorMsgUpdate } = this.props;
                await handleErrorMsgUpdate(data.error);
            }

            if (data.previewHtml) {
                this.setState((prevState) => ({
                    ...prevState,
                    error: '',
                    previewHtml: data.previewHtml
                }));
            }

        }
        else {
            const { handleErrorMsgUpdate } = this.props;
            await handleErrorMsgUpdate('Validation Error. Please fill all required fields.');
        }

    }

    handleSaveHTML = async () => {

        const { handleSaveChanges } = this.props;
        const { widget } = this.state;
        const thisWidget = this.props.thisWidget;
        let { id, widgetType } = thisWidget;

        // Update email verification status
        await this.getUser()

        // Update widget subscription status
        let widgetStatusData = id ? await this.updateWidgetStatus(id) : null;
        let subStatus = id && widgetStatusData ? widgetStatusData.subStatus : '';
        let expires = id && widgetStatusData ? widgetStatusData.expires : '';

        let paidWidget = false;
        if (widgetType.price != 0 && widgetType.price != undefined) {
            paidWidget = true;
        }

        // Validate common required fields
        const { handleErrorMsgUpdate } = this.props;
        if (!widget.title) {

            await handleErrorMsgUpdate('Please enter a title for this widget.');
            return;
        }

        // Validate widget based required fields
        let type = widgetType.name;
        let error = "";
        switch (type) {
            case "appfolio":
                if (!widget.htmlData.appfolio.appfolioUrl) {
                    error = "Please Enter - Appfolio Listings URL";
                }
                break;
            case "accessibility":
                if (!widget.htmlData.accessibility.domainUrl) {
                    error = "Please Enter your website URL";
                }
                break;
            case "trustpilot":
                if (!widget.htmlData.trustpilot.url) {
                    error = "Please Enter your Trustpilot Profile URL";
                }
                break;
            case "rentvine":
                if (!widget.htmlData.rentvine.rentvineUrl) {
                    error = "Please Enter your Rentvine Profile URL";
                }
                break;
            case "tripadvisor":
                if (!widget.htmlData.tripadvisor.url) {
                    error = "Please Enter your TripAdvisor Profile URL";
                }
                break;
            case "yelp":
                if (!widget.htmlData.yelp.url) {
                    error = "Please Enter your yelp Bussiness URL";
                }
                if (!widget.htmlData.yelp.businessId) {
                    error = "Please Enter the Yelp Bussiness ID"
                }
                break;
            default:
                break;
        }

        // Display error
        if (error) {
            await handleErrorMsgUpdate(error, "");
            return;
        } else {
            handleErrorMsgUpdate("", "");
        }

        // Check email verification
        if (!this.state.emailVerified) {
            this.state.verifyMailPopup.current.openPopup(this.state.email);
            return;
        }

        // Ask for purchase for paid widgets
        if (paidWidget) { // !widget.isPro &&

            if (subStatus) {

                switch (subStatus) {
                    case "active":
                        // This check is for manula orders, status needs to updated manually
                        if (expires) {
                            const widgetExpires = new Date(expires);
                            const today = new Date();
                            if (today > widgetExpires) {
                                this.state.purchasePopup.current.openPopup({ ...widget, id, subStatus });
                                return;
                            }
                        }
                        else {

                            this.state.purchasePopup.current.openPopup({ ...widget, id, subStatus });
                            return;
                        }
                        break;
                    case "incomplete":
                    case "past_due":
                        const hostedUrl = widgetStatusData?.hostedUrl || '';
                        this.state.purchasePopup.current.openPopup({ ...widget, id, subStatus }, hostedUrl);
                        return;
                    case "canceled":
                    case "expired":
                    case "incomplete_expired":
                    case "unpaid":
                    default:
                        this.state.purchasePopup.current.openPopup({ ...widget, id, subStatus });
                        return;

                }

            } else {
                this.state.purchasePopup.current.openPopup({ ...widget, id, subStatus });
                return;
            }

        }

        // Save the widget & Preview
        await handleSaveChanges(widget);
        this.setState(
            (prevState) => {
                return ({
                    ...prevState,
                    // previewHtml: '',
                })
            },
            () => {
                this.previewWidget(widget);
            }
        );
    };

    render() {

        const { selectedEditor, widget, previewHtml, installPopup, verifyMailPopup, infoPopup } = this.state;

        const thisWidget = this.props.thisWidget;

        let { widgetType } = thisWidget;

        let paidWidget = false;
        if (widgetType.price != 0 && widgetType.price != undefined) {
            paidWidget = true;
        }

        return (

            <div className="mjwi-editor">
                <div className={'mjwi-error-main' + (this.state.error ? '' : ' mjwi-hidden')}>{this.state.error}</div>
                <EditorLeftbar tabs={['Builder', 'Layout']} activeTab={selectedEditor} handleLeftBarClick={this.handleLeftBarClick} />
                <div className="mjwi-editor-main">

                    {widgetType.name === "appfolio" && (
                        <ListingsForAppfolio
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                            updateWrapperWidget={this.updateWrapperWidget}
                        />
                    )}
                    {widgetType.name === "rentvine" && (
                        <ListForRentvine widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                            updateWrapperWidget={this.updateWrapperWidget}
                        >
                        </ListForRentvine>
                    )}

                    {widgetType.name === "accessibility" && (
                        <Accessibility
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                            updateWrapperWidget={this.updateWrapperWidget}
                        />
                    )}

                    {widgetType.name === "trustpilot" && (
                        <Trustpilot
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                        />
                    )}

                    {widgetType.name === "prorated" && (
                        <Prorated
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                            updateWrapperWidget={this.updateWrapperWidget}
                        />
                    )}
                    {widgetType.name === "yelp" && (
                        <Yelp
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                        />
                    )}

                    {widgetType.name === "affordability" && (
                        <Affordability
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                        />
                    )}

                    {widgetType.name === "tripadvisor" && (
                        <TripAdvisior
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                        />
                    )}

                    {widgetType.name === "monthlypayment" && (
                        <MonthlyPayment
                            widget={thisWidget}
                            selectedEditor={selectedEditor}
                            previewWidget={this.previewWidget}
                            updateWrapperWidget={this.updateWrapperWidget}
                        />
                    )}

                    <div className="mjwi-editor-bottom">
                        {widgetAboutData[widgetType.name] &&
                            <div className='mjwi-widget-about-wrapper' onClick={(e) => this.state.infoPopup?.current?.openPopup(widgetAboutData[widgetType.name])}>
                                How it works?
                                <i class="fa-solid fa-circle-info"></i>
                            </div>}
                        <Button name="Save" eventHandler={this.handleSaveHTML} />
                        {
                            (thisWidget.id) ?
                                <Button name="Install" eventHandler={() => { installPopup.current.openPopup(thisWidget, widgetType.name) }} />
                                :
                                <Button name="Preview" eventHandler={this.previewWidgetOnClick} />
                        }
                    </div>
                </div>
                <div className=" mjwi-editor-display">
                    <div
                        // data-widget={JSON.stringify({ widgetData: widget })}
                        className="mj-widget mode-preview"
                        id={"mjwi-" + widgetType.name + "-preview"}
                    >
                        <div className={'mj-' + widgetType.name}>

                            {previewHtml && (
                                <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
                            )}

                        </div>
                    </div>
                </div>

                {/* <VerifyPassPopup ref={this.state.verifyPassPopup} updateVerifyPassState={this.updateVerifyPassState} /> */}

                {paidWidget && (
                    <PurchasePopup ref={this.state.purchasePopup} />
                )}

                <InstallPopup ref={installPopup} />
                <ResenMailPopup ref={verifyMailPopup} />
                <InfoPopup ref={infoPopup} />

            </div>

        );
    }
}

export default WidgetWrapper;
